<template>
  <vs-popup
    id="modal-painel-comercial"
    :active="isVisible"
    @close="closeModal"
    :class="`modal-style modalWidthFull`"
  >
    <div class="modal-content">
      <header class="py-4 px-6 flex justify-between sticky left-0">
        <strong class="vs-popup-title"
          >{{ this.translateTitle }} - {{ consultantName }}</strong
        >
        <button
          @click="handleCloseButtonClick"
          class="close-button rounded-full flex items-center justify-center p-2"
        >
          <XIcon class="icon" />
        </button>
      </header>
      <table class="modal-table">
        <thead>
          <tr>
            <th>ID da Proposta</th>
            <th>Nome do Cliente</th>
            <th>Ultima Atualização</th>
          </tr>
        </thead>
        <tbody v-if="hasPendingProposals">
          <tr v-for="(proposal, id_proposta) in proposals" :key="id_proposta">
            <td>
              <a
                :href="`/editarCotacao2/${proposal.id_proposta}`"
                style="color: #0f4173"
                target="_blank"
              >
                {{ proposal.id_proposta }}
              </a>
            </td>
            <td>
              <a
                :href="`/DetalheAssociado/${proposal.id_prospect}`"
                style="color: #0f4173"
                target="_blank"
                >{{
                  proposal.responsavelUser ? proposal.responsavelUser : '-'
                }}</a
              >
            </td>
            <td>{{ formatDate(proposal.updatedAt) }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5" class="text-center">
              Nenhuma proposta pendente de aprovação.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <vs-pagination
      :color="colorx"
      :total="qtdPaginas"
      v-model="paginaAtual"
      @change="handlePageChange"
      class="mt-5"
    ></vs-pagination>
  </vs-popup>
</template>

<script>
import { XIcon } from 'vue-feather-icons';
export default {
  name: 'ProposalModal',
  props: {
    title: {
      type: String,
      required: true,
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
    pendingProposals: {
      type: Array,
      required: true,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    qtdTotal: {
      type: Number,
      default: 0,
    },
    qtdPaginas: {
      type: Number,
    },
    consultantName: {
      type: String,
      default: '',
    },
  },
  watch: {
    async title() {
      await this.translateTitleService();
    },
    async pendingProposals(newValue, oldValue) {
      if (JSON.stringify(newValue) === JSON.stringify(oldValue)) {
        return;
      }
      if (this.pendingProposals.length === 0) {
        return;
      }
      this.proposals = this.pendingProposals;
      this.hasPendingProposals = true;
    },
  },
  data() {
    return {
      translateTitle: '',
      hasPendingProposals: false,
      proposals: [],
      itemsPerPage: 10,
      paginaAtual: 1,
      colorx: '#0f4173',
    };
  },
  components: {
    XIcon,
  },
  methods: {
    closeModal() {
      this.hasPendingProposals = false;
      this.proposals = [];
      this.paginaAtual = 1;
      this.$emit('update:isVisible', false);
      this.$emit('close-modal');
    },
    handleCloseButtonClick(event) {
      event.stopPropagation();
      this.closeModal();
    },
    formatDate(dateString) {
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },
    async translateTitleService() {
      const titleMap = {
        assignments: 'Atribuições',
        finalized: 'Aprovações',
        awaitingApproval: 'Aguardando Aprovação',
        pending: 'Pendências',
        rejected: 'Reprovações',
      };

      this.translateTitle = titleMap[this.title] || this.title;
    },
    getStatusName(statusId) {
      const statusMap = {
        2: 'Recusada',
        3: 'Aguardando Aprovação',
        4: 'Finalizada',
        5: 'Pendente',
      };

      return statusMap[statusId] || 'Status Desconhecido';
    },
    async handlePageChange(page) {
      this.paginaAtual = page;
      this.$emit('page-changed', this.paginaAtual);
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500&display=swap');

#modal-painel-comercial .vs-popup--header {
  display: none;
}

.modalWidthFull .vs-popup {
  width: 100%;
  padding: 0;
}

#modal-painel-comercial .vs-popup {
  border-radius: 10px;
  overflow: hidden;
  max-width: 1200px;
  margin: auto;
}

#modal-painel-comercial .vs-popup--content {
  display: block;
  overflow-y: auto;
  scrollbar-color: #114880 transparent;
  scrollbar-width: thin;
}

#modal-painel-comercial .modal-content::-webkit-scrollbar-button {
  display: none;
}

#modal-painel-comercial .modal-content {
  background-color: #fff;
}

#modal-painel-comercial .modal-table {
  width: 100%;
  border-collapse: collapse;
}

#modal-painel-comercial .modal-table thead th {
  color: #0f4173;
  border-bottom: 1px solid #0f4173;
  padding: 12px 8px;
  text-align: left;
  white-space: nowrap;
  font-weight: 500;
}

#modal-painel-comercial .modal-table tbody {
  background-color: #fff;
}

#modal-painel-comercial .modal-table tbody tr:nth-child(even) {
  background-color: #cfdae6;
}

#modal-painel-comercial .modal-table tbody td {
  padding: 12px 8px;
  text-align: left;
  white-space: nowrap;
  font-size: 0.875rem;
}

#modal-painel-comercial .vs-popup-close {
  color: white;
  font-size: 1.25rem;
}

#modal-painel-comercial header strong {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #434343;
}

#modal-painel-comercial .icon {
  width: 12px;
  height: 12px;
  color: #fff;
}

#modal-painel-comercial .close-button {
  border: none;
  background: none;
  cursor: pointer;
  background-color: #0f4173;
}

#modal-painel-comercial .modal-content {
  overflow-x: auto;
}

#modal-painel-comercial .cpfcnpj {
  color: #0f4173;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}
.text-xxs {
  font-size: 0.625rem;
  line-height: 1rem;
}
</style>
